import React, { useState, useEffect } from "react";
import { Modal, Input, Switch, Select, Tooltip, Radio, Checkbox } from "antd";
import floppyDiskImg from "../../../../assets/img/floppy-disk.svg";
import puzzle from "../../../../assets/img/bl.svg";
import { ReceptionRadioButtons } from "../buttons/reception-button.js";
import {
  TackleRadioButtons,
  CarryRadioButtons,
  PuntDistance,
  FlagSwitchButtons,
} from "../CustomSwitchButtons.js";
import positiveImpact from "../../../../assets/img/positiveImpact.svg";
import positiveImpactAction from "../../../../assets/img/Action.svg";
import maskSquare from "../../../../assets/img/mask-square.png";

function KickerModal({
  state,
  dispatch,
  close,
  update,
  item,
  school_id,
  loadAllPlayerList,
  play,
  handleUpdatePlay,
  updateInputGrade,
  updateGrade,
  handleExpandToggle,
  handleQuickUpdate,
  setStoreItem,
  storeItem,
  distanceModal,
  setDistanceModal,
  lastOpenedById,
  setLastOpenedById,
}) {
  const [modalWidth, setModalWidth] = useState(550);
  const [showMoreOnside, setShowMoreOnside] = useState(false);
  const [showMoreKickoff, setShowMoreKickoff] = useState(false);
  const [openFieldGoal, setFieldGoal] = useState(false);
  const [openMissedFG, setMissedFG] = useState(false);
  const [isMissed, setIsMissed] = useState(false);
  const [distance, setDistance] = useState(
    isMissed ? item.missed_field_goal_distance : item.field_goal_distance
  );
  const [distancePunt, setDistancePunt] = useState(item.punts);
  const [openPuntModal, setOpenPuntModal] = useState(false);
  const [fair, setFair] = useState(item.punt_fair_catch);
  const [inside, setInside] = useState(item.punt_inside_20);

  useEffect(() => {
    if (showMoreKickoff || showMoreOnside) {
      setModalWidth(752);
    }
  }, [showMoreKickoff, showMoreOnside]);

  useEffect(() => {
    if (window.innerWidth <= 768) {
      setModalWidth(552);
    } else {
      setModalWidth(525);
    }
  }, [window.innerWidth]);

  useEffect(() => {
    if (item?.field_goals === 4) {
      setFieldGoal(true);
      setMissedFG(false);
      setIsMissed(false);
    } else if (item?.field_goals === 0) {
      setFieldGoal(false);
      setMissedFG(true);
      setIsMissed(true);
    } else {
      setFieldGoal(false);
      setMissedFG(false);
      setIsMissed(false);
    }
  }, [item?.field_goals]);

  useEffect(() => {
    if (item?.punts && item?.punts == 1) {
      setOpenPuntModal(true);
    } else {
      setOpenPuntModal(false);
    }
  }, [item?.punts]);

  useEffect(() => {
    if (!item) return;
    if (isMissed) {
      setDistance(item.missed_field_goal_distance ?? "");
    } else {
      setDistance(item.field_goal_distance ?? "");
    }
  }, [item, isMissed]);

  console.log(
    isMissed,
    item.field_goal_distance,
    item.missed_field_goal_distance
  );

  return (
    state.kicker && (
      <div className="w-full text-[12px] flex justify-between text-[#0F1A24]">
      <div
        style={{ border: "1px solid #F3F5F7" }}
        className="w-[49%]"
      >
        <div
          className="flex items-center"
          style={{ borderBottom: "1px solid #F3F5F7" }}
        >
          <div
            className="w-[25%] px-2 py-2 font-bold"
            style={{ borderRight: "1px solid #F3F5F7" }}
          >
            <span>PAT</span>
          </div>{" "}
          <div className="px-2 py-2 w-fit turn-over actor">
            <>
              <TackleRadioButtons
                item={item}
                defaultState={item?.pat}
                handleQuickUpdate={(a, b, c, d, e, f) => {
                  setStoreItem(item);
                  e = false;
                  handleQuickUpdate(a, b, c, d, e, f);
                }}
                title="pat"
                imageTwo={maskSquare}
                tooltipTitle="Missed"
                value="1"
                tooltipTitleTwo="Blocked"
                color="yellow"
                text={item?.pat}
              />
            </>
          </div>
        </div>

        <div
          className="flex items-center"
          style={{ borderBottom: "1px solid #F3F5F7" }}
        >
          <div
            className="w-[25%] px-2 py-2 font-bold"
            style={{ borderRight: "1px solid #F3F5F7" }}
          >
            <span>PUNT</span>
          </div>{" "}
          <div className="px-2 py-2 w-[15%] turn-over actor flex items-center justify-center">
            <>
              <CarryRadioButtons
                item={item}
                defaultState={item?.punts}
                handleQuickUpdate={(a, b, c, d, e, f) => {
                  if (d != 0) {
                    // handleExpandToggle(item, "punt-modal");
                    setOpenPuntModal(true);
                    e = false;
                  } else {
                    e = false;
                  }
                  setStoreItem(item);
                  handleQuickUpdate(a, b, c, d, e, {
                    default: item.punt_distance,
                    path: "punt_distance",
                    hasOptions: true,
                    title: "Punt",
                  });
                }}
                title="punts"
                img={maskSquare}
                tooltipTitle="Blocked"
                value="1"
                color="yellow"
              />

              <PuntDistance
                // updateProps ={}
                item={storeItem || item}
                distanceModal={distanceModal}
                handleQuickUpdate={handleQuickUpdate}
                setDistanceModal={setDistanceModal}
                defaultState={item?.punts}
              />
            </>
          </div>
        </div>
        {openPuntModal && (
          <div className="flex flex-col w-full mt-2 text-[#20364B] text-sm font-semibold">
            <div className="border rounded-md overflow-hidden">
              <div className="flex w-full">
                <div className="w-[25%] p-2 flex items-center justify-center bg-[#F3F5F7] border-r">
                  Punt
                </div>
                <div className="w-[20%] p-2 flex items-center justify-center border-r">
                  <Input
                    size="small"
                    className="w-[70%]"
                    defaultValue={distancePunt}
                    onChange={({ target: { value } }) => setDistancePunt(value)}
                    onPressEnter={() =>
                      update(item.id, item.athlete, "punts", distancePunt)
                    }
                  />
                </div>
                <div className="w-[25%] p-2 flex items-center justify-center border-r">
                  <Checkbox
                    defaultChecked={item?.punt_inside_20}
                    onChange={({ target: { checked: e } }) => {
                      const val = e ? 1 : 0;
                      setInside(val);
                      update(item.id, item.athlete, "punt_inside_20", val);
                    }}
                  />
                  <span className="ml-1 font-normal">Inside 20</span>
                </div>
                <div className="w-[30%] p-2 flex items-center justify-center">
                  <Checkbox
                    defaultChecked={item.punt_fair_catch}
                    onChange={({ target: { checked: e } }) => {
                      const val = e ? 1 : 0;
                      setFair(val);
                      update(item.id, item?.athlete, "punt_fair_catch", val);
                    }}
                  />
                  <span className="ml-1 font-normal">Fair Catch</span>
                </div>
              </div>
            </div>
          </div>
        )}

        <div
          className={`flex items-center ${
            openFieldGoal || openMissedFG ? "justify-between" : ""
          }`}
          style={{ borderBottom: "1px solid #F3F5F7" }}
        >
          <div
            className="w-[25%] px-2 py-2 font-bold"
            style={{ borderRight: "1px solid #F3F5F7" }}
          >
            <span>FG</span>
          </div>{" "}
          <div
            className={`px-2 py-2  w-[15%] turn-over actor flex items-center justify-center`}
          >
            <TackleRadioButtons
              item={item}
              defaultState={item?.field_goals}
              title="field_goals"
              imageTwo={maskSquare}
              text={item?.field_goals}
              tooltipTitle="Missed"
              tooltipTitleThree="Good"
              value="1"
              color="yellow"
              tooltipTitleTwo="Blocked"
              // handleQuickUpdate={props.handleQuickUpdate}
              handleQuickUpdate={(a, b, c, d, e, f) => {
                let title;
                let defaultState;
                let path;
                e = false;
                const currentId = item.id;
                const lastD = lastOpenedById[currentId];
                if (d == 4) {
                  title = "Field Goal Distance";
                  defaultState = item.field_goal_distance;
                  path = "field_goal_distance";
                } else if (d == 0) {
                  title = "Missed Field Goal Distance";
                  defaultState = item.missed_field_goal_distance;
                  path = "missed_field_goal_distance";
                } else {
                  e = false;
                }
                setStoreItem(item);
                if (d === 4) {
                  // handleExpandToggle(item, "field_goal_distance");
                  setFieldGoal(true);
                  setMissedFG(false);
                }
                if (d === 0) {
                  // handleExpandToggle(item, "missed_field_goal_distance");
                  setFieldGoal(false);
                  setMissedFG(true);
                }
                if (lastD === d) return;
                setLastOpenedById((prev) => ({ ...prev, [currentId]: d }));
                handleQuickUpdate(a, b, c, d, e, {
                  hasOptions: false,
                  default: defaultState,
                  title,
                  path,
                });
              }}
            />
          </div>
          {(openFieldGoal || openMissedFG) && (
            <div className="w-[55%]">
              <div
                style={{ border: "1px solid #F3F5F7" }}
                className="w-full flex flex-col text-sm font-bold text-[#20364B]"
              >
                <div className="w-full flex">
                  <div
                    style={{ border: "1px solid #F3F5F7" }}
                    className={`${
                      isMissed ? "w-[70%]" : "w-[60%]"
                    } flex items-center px-2 py-2 justify-center`}
                  >
                    <span>
                      {isMissed
                        ? "Missed Field Goal Distance"
                        : "Field Goal Distance"}
                    </span>
                  </div>
                  <div
                    style={{ border: "1px solid #F3F5F7" }}
                    className={`${
                      isMissed ? "w-[30%]" : "w-[40%]"
                    } flex items-center px-2 py-2 justify-center turn-over actor`}
                  >
                    <Input
                      defaultValue={distance}
                      onChange={({ target: { value } }) => setDistance(value)}
                      className="w-[98%]"
                      size="large"
                      onPressEnter={() => {
                        update(
                          item.id,
                          item.athlete,
                          isMissed
                            ? "missed_field_goal_distance"
                            : "field_goal_distance",
                          distance
                        );
                      }}
                    />
                  </div>
                </div>
              </div>
              {/* <div className="flex items-center justify-between text-md mt-2 w-full flex-col">
              <button
                onClick={() => {
                  update(
                    item.id,
                    item.athlete,
                    isMissed
                      ? "missed_field_goal_distance"
                      : "field_goal_distance",
                    distance
                  );
                  handleExpandToggle(
                    item,
                    isMissed
                      ? "missed_field_goal_distance"
                      : "field_goal_distance"
                  );
                }}
                className="flex items-center focus:outline-0 self-end justify-center w-[30%] bg-[#1A91FF] text-[#ffffff] py-2 px-3 rounded-[4px]"
              >
                <img src={floppyDiskImg} className="w-4" />
                <span className="ml-2">Save and close</span>
              </button>
            </div> */}
            </div>
          )}
        </div>

        <div
          className="flex items-center"
          style={{ borderBottom: "1px solid #F3F5F7" }}
        >
          <div
            className="w-[25%] px-2 py-2 font-bold"
            style={{ borderRight: "1px solid #F3F5F7" }}
          >
            <span>Kickoff</span>
          </div>{" "}
          <div className="px-2 py-2 w-[15%] turn-over actor flex items-center justify-center">
            <Switch
              defaultChecked={item.kickoff}
              onChange={(e) => {
                setShowMoreKickoff(e);
                updateGrade("kickoff", e ? 1 : 0);
              }}
            />{" "}
          </div>
          {showMoreKickoff || item.kickoff ? (
            <>
              <div className="px-2 py-2 w-[60%] turn-over actor flex items-center justify-center">
                <Radio.Group
                  name="radiogroup"
                  onChange={({ target: { value } }) => {
                    updateGrade("kickoff_touchback", value === 1 ? 0 : 1);
                    updateGrade("kickoff_fair_catch", value);
                  }}
                  defaultValue={item.kickoff_fair_catch}
                >
                  <Radio value={0}>
                    {" "}
                    <span className="text-[#2E4D6B]">Touchback</span>
                  </Radio>
                  <Radio value={1}>
                    {" "}
                    <span className="text-[#2E4D6B]">Fair Catch </span>
                  </Radio>
                </Radio.Group>
              </div>{" "}
            </>
          ) : null}
        </div>

        <div
          className="flex items-center"
          style={{ borderBottom: "1px solid #F3F5F7" }}
        >
          <div
            className="w-[25%] px-2 py-2 font-bold"
            style={{ borderRight: "1px solid #F3F5F7" }}
          >
            <span>Onside Kick</span>
          </div>{" "}
          <div className="px-2 py-2 w-[15%] turn-over actor flex items-center justify-center">
            <Switch
              defaultChecked={item.onsidekick}
              onChange={(e) => {
                setShowMoreOnside(e);
                updateGrade("onsidekick", e ? 1 : 0);
              }}
            />{" "}
          </div>
          {showMoreOnside || item.onsidekick ? (
            <>
              {" "}
              <div className="p-3 w-[60%] turn-over actor flex items-center justify-center">
                <Checkbox
                  defaultChecked={Number(item.recovered_fumble)}
                  onChange={({ target: { checked: e } }) =>
                    updateGrade("recovered_fumble", e ? 1 : 0)
                  }
                >
                  <span className="text-[#2E4D6B]">Recovered</span>
                </Checkbox>
              </div>{" "}
            </>
          ) : null}
        </div>

        <div
          className="flex items-center"
          style={{ borderBottom: "1px solid #F3F5F7" }}
        >
          <div
            className="w-[25%] px-2 py-2 font-bold"
            style={{ borderRight: "1px solid #F3F5F7" }}
          >
            <span>Flag</span>
          </div>{" "}
          <div className="px-2 py-2 w-[15%] turn-over actor flex items-center justify-center">
            <FlagSwitchButtons
              item={item}
              defaultState={item?.penalties}
              handleQuickUpdate={handleQuickUpdate}
              title="penalties"
            />
          </div>
        </div>

        <div
          className="flex items-center"
          style={{ borderBottom: "1px solid #F3F5F7" }}
        >
          <div
            className="w-[25%] px-2 py-2 font-bold"
            style={{ borderRight: "1px solid #F3F5F7" }}
          >
            <span>Positive Impact</span>
          </div>{" "}
          <div className="px-2 py-2 w-[15%] turn-over actor flex items-center justify-center">
            <div
              onClick={() => {
                if (item?.disabled) return;
                handleQuickUpdate(
                  item.id,
                  item.athlete,
                  "positive_impact",
                  !item?.positive_impact ? 1 : 0
                );
              }}
              className="flex w-[100%] items-center justify-center"
            >
              {item?.positive_impact == 1 && (
                <img
                  src={positiveImpactAction}
                  className="w-[60%] max-w-[35px] cursor-pointer"
                />
              )}
              {(item?.positive_impact === 0 || !item?.positive_impact) && (
                <img
                  src={positiveImpact}
                  className="w-[60%] max-w-[35px] cursor-pointer"
                />
              )}
            </div>
          </div>
        </div>

      </div>
        <div className="w-[49%]">
          <button
            onClick={() => handleExpandToggle(item, "kicker-modal")}
            className="flex items-center focus:outline-0 justify-center w-fit bg-[#1A91FF] text-[#ffffff] px-3 py-2 rounded-[4px]"
          >
            <img src={floppyDiskImg} className="w-6" />
            <span className="ml-2">Save and close</span>
          </button>
        </div>
      </div>
    )
  );
}

export default KickerModal;
